import React, { useState } from "react";
import styles from "../css/styles.module.css";

export default function EditCustomer(props) {
  const [customer, setCustomer] = useState({
    name: props.customer.data.name,
    address: props.customer.data.address,
    phone: props.customer.data.phone,
    website: props.customer.data.website,
  });

  function handleChange(e) {
    setCustomer({
      ...customer,
      [e.target.name]: e.target.value,
    });
  }

  return (
    <div className={styles.form}>
      <form onSubmit={(e) => props.handleEditSubmit(e, customer)}>
        <h1>Edit Customer</h1>
        <input
          type="text"
          name="name"
          value={customer.name}
          onChange={(e) => handleChange(e)}
          required
        />
        <input
          type="text"
          name="address"
          value={customer.address}
          onChange={(e) => handleChange(e)}
        />
        <input
          type="text"
          name="phone"
          value={customer.phone}
          onChange={(e) => handleChange(e)}
        />
        <input
          type="text"
          name="website"
          value={customer.website}
          onChange={(e) => handleChange(e)}
        />
        <button type="submit">Edit</button>
      </form>
      <button className={styles.cancelButton} onClick={props.handleCancelClick}>
        Cancel
      </button>
    </div>
  );
}
